/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Channel from '@/components/channel'
import DownloadPC from '@/components/downloadPC'
import DownloadH5 from '@/components/downloadH5'
import HomeMobile from '@/components/HomeMobile.vue';

Vue.use(Router)

export default new Router({
        routes: [{
                path: '/',
                name: 'HelloWorld',
                component: HelloWorld,
            },
            {
                path: '/download_pc',
                name: 'DownloadPC',
                component: DownloadPC
            },
            {
                path: '/download_h5',
                name: 'DownloadH5',
                component: DownloadH5
            },
            {
                path: '/download_qw',
                name: 'HomeMobile',
                component: HomeMobile
            }
        ]
    })
    /* eslint-disable */



// WEBPACK FOOTER //
// ./src/router/index.js